import axios from 'axios';
import {
  CaseFileInspectionInputModel,
  CaseFileInspectionOutputModel
} from 'app/edozvola/case-file-inspection/model/case-file-inspection.model';
import { CaseModel } from 'app/edozvola/cases/cases.model';

export const getFileInspectionData = async (fileInspectionInputData: CaseFileInspectionInputModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/case-file-inspection`, fileInspectionInputData)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const getFileInspectionCaptchaEnabled = async (): Promise<boolean> => {
  return await new Promise((resolve) => {
    axios
      .get(`api/cases/case-file-inspection/recaptcha`)
      .then(result => resolve(result.data));
  })
}
